import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class LoaderSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'loader');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        const translate = style => this.admin.i18n.instant(`ADMIN.EDITORS.THEME.SETTINGS.LOADER.STYLE.${style}`);
        return [
            this.comboField('style', {
                [translate('PULSE')]: 'pulse',
                [translate('RAINBOW')]: 'rainbow',
                [translate('UNEVEN_LINES')]: 'uneven-lines',
                [translate('SPINNER')]: 'spinner',
            }),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),
        ];
    }

}
